import { supabase } from './supabase';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function uploadFile(path, file) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.detail || body?.message || `HTTP ${res.status}`);
  return body;
}
